export default {
  recommendationTag: {
    id: 'product_card_recommendation_tag',
    defaultMessage: 'Good deal',
  },
}
